let hstnm = '192.168.130.201';
let hstprt = 8072;

// !!! UNCOMMENT NEXT THREE LINES FOR BUILD !!! ( / * * /)


hstnm = window.location.hostname;
hstprt = 80;
if (window.location.port) hstprt = parseInt(window.location.port);



module.exports = {
    serverPort : hstprt,
    serverIp : hstnm,
    serverApiPath : "/api/v1"
}